import { firestore } from 'firebase/app'
import { FirestoreQuery } from '../Firestore/FirestoreQuery'
import { MasterCatalog } from './MasterCatalog'
import { MasterCatalogMapper } from './MasterCatalogMapper'
import { PriceListEntry } from '../PriceList/PriceListEntry/PriceListEntry'
import { v4 as uuid } from 'uuid'

export class MasterCatalogCollection {
  protected collection: string = 'masterCatalog'

  constructor(protected db: firestore.Firestore, protected batch?: firestore.WriteBatch) {}

  watchMasterCatalogsByCompanyId(companyId: string): MasterCatalog[] {
    const query = this.initQuery()
    query.setQuery(this.getMasterCatalogsByCompanyIdQuery(query, companyId))
    return query.watchList()
  }

  list(): Promise<MasterCatalog[]> {
    const query = this.initQuery()
    return query.list()
  }

  listMasterCatalogsByCompanyId(companyId: string): Promise<MasterCatalog[]> {
    const query = this.initQuery()
    query.setQuery(this.getMasterCatalogsByCompanyIdQuery(query, companyId))
    return query.list()
  }

  watch(id: string): { data: MasterCatalog | null, unsub: () => void } {
    const query = this.initQuery()
    return query.watch(id)
  }

  get(id: string): Promise<MasterCatalog | null> {
    const query = this.initQuery()
    return query.find(id)
  }

  async getByCompanyId(companyId: string): Promise<MasterCatalog | null> {
    const query = this.initQuery()
    query.setQuery(
      query.collection(this.collection).where('companyId', '==', companyId)
    )
    const backorders = await query.list()
    return backorders.length ? backorders[0] : null
  }

  save(masterCatalog: MasterCatalog): Promise<MasterCatalog> {
    // dedup entries
    const dedupedEntries = new Map<string, PriceListEntry>();
    masterCatalog.entries.forEach(entry => {
      entry.description = entry.description.trim()
      const key = entry.description + entry.upc;
      const existingEntry = dedupedEntries.get(key);
      if (!existingEntry) {
        dedupedEntries.set(key, entry);
      }

      if(!entry.upc || entry.upc === '') {
        entry.upc = uuid()
      }
    })
    masterCatalog.entries = [...dedupedEntries.values()];

    const query = this.initQuery()
    return query.save(masterCatalog)
  }

  async delete(masterCatalog: MasterCatalog) {
    const query = this.initQuery();
    return query.delete(masterCatalog)
  }

  protected initQuery(): FirestoreQuery<MasterCatalog> {
    const query = new FirestoreQuery<MasterCatalog>(this.db, new MasterCatalogMapper())
    query.collection(this.collection)

    return query
  }

  protected getMasterCatalogsByCompanyIdQuery(query: FirestoreQuery<MasterCatalog>, companyId: string) {
    return query.collection(this.collection).where('companyId', '==', companyId)
  }
}
